import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// --- НАЧАЛО ИСПРАВЛЕННОГО КОДА ДЛЯ ПРЕДЗАГРУЗКИ ---

// 1. Импортируем ТОЛЬКО getSliderData. getSliderImageUrl нам больше нахуй не нужна.
import { getSliderData } from './firebase/sliderService';

// 2. Создаем асинхронную функцию, которая выполнит предзагрузку
const preloadFirstSlideImage = async () => {
  try {
    // Запускаем предзагрузку изображения первого слайда

    // Запрашиваем данные о слайдах. Это один быстрый запрос.
    const sliderData = await getSliderData();

    // Проверяем, что массив слайдов не пустой
    if (sliderData && sliderData.length > 0) {
      
      // Берем самый первый слайд
      const firstSlide = sliderData[0];
      
      // ИЗМЕНЕНИЕ: Мы больше не вызываем getSliderImageUrl.
      // Мы, сука, просто проверяем, что в поле 'image' лежит готовая ссылка.
      if (firstSlide && firstSlide.image && typeof firstSlide.image === 'string') {
        
        const imageUrl = firstSlide.image; // <-- Просто, блять, берем готовую ссылку

        // Создаем в памяти HTML-элемент <link>
        const preloadLink = document.createElement('link');
        
        // Назначаем ему атрибуты для предзагрузки
        preloadLink.rel = 'preload';
        preloadLink.as = 'image';
        preloadLink.href = imageUrl;
        
        // Добавляем тег в <head> HTML-страницы. Браузер начнет качать картинку.
        document.head.appendChild(preloadLink);
        
        // Тег preload для первого слайда успешно добавлен в <head>
      } else {
        // У первого слайда нет готовой ссылки в поле "image"
      }
    } else {
      // Активные слайды для предзагрузки не найдены
    }
  } catch (error) {
    // Если что-то пойдет не так, мы не ломаем приложение
  }
};

// 3. Вызываем нашу функцию
preloadFirstSlideImage();

// --- КОНЕЦ КОДА ДЛЯ ПРЕДЗАГРУЗКИ ---


// Эта часть кода у тебя уже есть. Она остается без изменений.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Эта часть кода у тебя уже есть. Она остается без изменений.
reportWebVitals();